<template>
  <section>
    <b-row>
      <b-col md="12">
        <h4 id="tailieTitleText">{{ $t("match-no-fit-title") }}</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <p>{{ $t("match-no-fit-message") }}</p>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "components-match-no-fit",
  created() {
    this.$store.commit(
      "ui/SET_POST_LOADING_TEXT",
      this.$t("match-loading-no-size-found")
    );
    this.$store.commit("ui/SET_POST_LOADING_ANIMATION_SIZE_NOT_FOUND");
  },
  computed: {
    ...mapGetters({
      matchSize: "users/getSelfMatchSize",
      productName: "pageParams/getProductName"
    })
  }
};
</script>
